import { z } from 'zod/v3'
import { productsSearchSchema } from '@/features/products'

const supplierDrawerSchema = z.union([
	z.object({
		mode: z.literal('edit'),
	}),
	z.object({
		mode: z.undefined().optional(),
	}),
])

const supplierDetailTabSchema = z.object({
	tab: z.enum(['data', 'products']).default('products'),
})

export const supplierDetailSearchSchema = supplierDrawerSchema.and(productsSearchSchema).and(supplierDetailTabSchema)

export type SupplierDetailSearch = z.infer<typeof supplierDetailSearchSchema>
